import { Expose } from 'class-transformer'

export class CoinType {
  @Expose()
  id: number

  @Expose()
  name: string

  @Expose()
  imgPath: string
}
